import template from './index.html';

export const appDirective = () => {
  return {
    template,
    restrict: 'E',
    scope: {},
    replace: true
  };
};



/** WEBPACK FOOTER **
 ** ./src/app/app.directive.js
 **/